module.exports = __webpack_public_path__ + "img/role_4.f6ad1ab3.png";